import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines'

import { IconCloverOutline1, IconFire, IconStar, IconTruck } from '../icons'

export const CardBadges = [
    { label: 'پرفروش', icon: IconFire, id: 'Bestseller' },
    { label: 'شانس', icon: IconCloverOutline1, id: 'Chance' },
    { label: 'ارسال رایگان', icon: IconTruck, id: 'FreeShipping' },
    { label: 'جدید', icon: IconStar, id: 'New' },
]

export const CardImageWidth = PUBLIC_IS_BOT ? 88 : 104
